import React from 'react';

interface CountryFlagProps {
  /** ISO 3166-1 alpha-2 country code (e.g. "BR", "US") */
  code: string;
  /** Width in pixels (default 20) */
  size?: number;
  className?: string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({ code, size = 20, className }) => {
  if (!code || code.length !== 2) return null;

  const iso = code.toLowerCase();

  return (
    <img
      src={`https://flagcdn.com/${iso}.svg`}
      width={size}
      height={Math.round(size * 0.75)}
      alt={code.toUpperCase()}
      className={className}
      loading="lazy"
      style={{ display: 'inline-block', verticalAlign: 'middle', borderRadius: 2, objectFit: 'cover' }}
    />
  );
};

export default CountryFlag;
